// Copy and Paste for Newsletter Emails
jQuery(document).ready(function() {
    function copyFunction() {
      var copyText = jQuery("#newsletter-template");
      copyText.select();
      document.execCommand("copy");
      jQuery("#copy-newsletter").addClass("copied");
      setTimeout(function() {
        jQuery("#copy-newsletter").removeClass("copied");
      }, 2500);
    }
    if (jQuery('#copy-newsletter').length) {
      jQuery('#copy-newsletter').on('click', copyFunction);
    }
});

// Giving newsletter images an inline style for email styling purposes
jQuery('.newsletter-content img').css({'max-width':'100%'});